import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HeaderSecundario from "../components/HeaderSecundario.js";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Radio } from "@material-ui/core";
import RadioGroup from "@material-ui/core/RadioGroup";
import M from "materialize-css";
import CirculosRojos from "../components/CirculosRojos.js";
import $ from "jquery";
import "../css/App.css";

export default function Gastos(props) {
  const [patentamiento, setPatentamiento] = useState(null);
  const [valorTotal, setValorTotal] = useState(0);

  const pol_0km =
    props.descuentos &&
    props.descuentos.descuentos &&
    props.descuentos.descuentos[0].Pol_0km;
  const pol_0km_Gastos =
    props.descuentos &&
    props.descuentos.descuentos &&
    props.descuentos.descuentos[0].Pol_0km_Gastos;
  /*   const pol_Usados = props.descuentos.descuentos[0].Pol_Usados;
  const pol_Usados_Gastos = props.descuentos.descuentos[0].Pol_Usados_Gastos; */

  const [clasePatentaConNosotros, setClasePatentaConNosotros] = useState(
    "patentamientoNoSeleccionado"
  );
  const [clasePatentaPorTuCuenta, setClasePatentaPorTuCuenta] = useState(
    "patentamientoNoSeleccionado"
  );

  useEffect(() => {
    var elems = document.querySelectorAll(".materialboxed");
    var instances = M.Materialbox.init(elems, {
      inDuration: 500,
      outDuration: 500,
    });
  }, []);

  useEffect(() => {
    actualizarTotal();
  }, [patentamiento]);

  useEffect(() => {
    var elems = document.querySelectorAll(".collapsible");
    var instances = M.Collapsible.init(elems, {
      accordion: true,
      inDuration: 300,
      outDuration: 300,
    });
  }, []);

  const actualizarTotal = () => {
    var total_pat = 0;
    var total = 0;

    if (props.vehiculo) {
      if (patentamiento == null) {
        setValorTotal(props.vehiculo.precio);
        total = props.vehiculo.precio;
      } else {
        // eslint-disable-next-line default-case
        switch (patentamiento) {
          case 0: //patentamiento con nosotros
            total_pat = props.vehiculo.pat_emp;

            if (props.vehiculo.moneda != "U$S") {
              total =
                props.vehiculo.precio -
                props.vehiculo.precio * pol_0km +
                props.vehiculo.pat_emp -
                props.vehiculo.pat_emp * pol_0km_Gastos;

              setValorTotal(total);

              total = Intl.NumberFormat("es-AR", {
                style: "currency",
                currency: "ARS",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }).format(total);
            } else {
              total =
                props.vehiculo.precio -
                props.vehiculo.precio * pol_0km +
                props.vehiculo.pat_emp -
                props.vehiculo.pat_emp * pol_0km_Gastos;
              setValorTotal(total);

              total =
                Intl.NumberFormat("es-AR", {
                  style: "currency",
                  currency: "USD",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(total) +
                " + " +
                Intl.NumberFormat("es-AR", {
                  style: "currency",
                  currency: "ARS",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(props.vehiculo.pat_emp);
            }
            break;
          case 1:
            total_pat = props.vehiculo.pat_cli;

            if (props.vehiculo.moneda != "U$S") {
              total =
                props.vehiculo.precio -
                props.vehiculo.precio * pol_0km +
                props.vehiculo.pat_cli;
              setValorTotal(total);

              total = Intl.NumberFormat("es-AR", {
                style: "currency",
                currency: "ARS",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }).format(total);
            } else {
              total = props.vehiculo.precio - props.vehiculo.precio * pol_0km;
              setValorTotal(total);

              total =
                Intl.NumberFormat("es-AR", {
                  style: "currency",
                  currency: "ARS",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(total) +
                " + " +
                Intl.NumberFormat("es-AR", {
                  style: "currency",
                  currency: "ARS",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(props.vehiculo.pat_cli);
            }
            break;
        }
      }

      var gastos = {
        total: total,
        patentamiento: patentamiento,
        total_pat: total_pat,
      };

      props.onGastoSeleccionado(gastos);
    }
  };

  const img = "https://store.lenken.com.ar/img/";

  const patentaConNosotros = () => {
    setPatentamiento(0);
    setClasePatentaConNosotros("patentamientoSeleccionado");
    setClasePatentaPorTuCuenta("patentamientoNoSeleccionado");
  };

  const patentaPorTuCuenta = () => {
    setPatentamiento(1);
    setClasePatentaConNosotros("patentamientoNoSeleccionado");
    setClasePatentaPorTuCuenta("patentamientoSeleccionado");
  };

  let patent;

  if (patentamiento == null) {
    patent = <div style={{ fontFamily: "Audi Extended" }}> </div>;
  } else if (patentamiento == 0) {
    patent = (
      <div style={{ fontFamily: "Audi Extended" }}>Patentas con nosotros</div>
      /*  <div style={{ fontFamily: "Audi Extended", color: "red" }}>
        DESCUENTO ONLINE
        <br />
        {Intl.NumberFormat("es-AR", {
          style: "currency",
          currency: "ARS",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(
          props.vehiculo.precio * pol_0km +
            props.vehiculo.pat_emp * pol_0km_Gastos
        )}{" "}
        INCLUIDO{" "}
      </div> */
    );
    $("#botonReservar").removeClass("disabled").addClass("black");
  } else {
    if (pol_0km === 0) {
      patent = (
        <div style={{ fontFamily: "Audi Extended" }}>
          Patentas por tu cuenta
        </div>
      );
    } else {
      patent = (
        <div style={{ fontFamily: "Audi Extended", color: "red" }}>
          DESCUENTO ONLINE
          <br />
          {Intl.NumberFormat("es-AR", {
            style: "currency",
            currency: "ARS",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }).format(
            props.vehiculo.precio * pol_0km +
              props.vehiculo.pat_emp * pol_0km_Gastos
          )}{" "}
          INCLUIDO{" "}
        </div>
      );
    }

    $("#botonReservar").removeClass("disabled").addClass("black");
  }

  const scrollTopAndReservar = () => {
    const urltgm_base = "https://store.lenken.com.ar/vtf/urltgm/";

    scrollTop();

    let url_tgm = `${urltgm_base}reservas.php?modelo=${props.vehiculo.modelo}&version=${props.vehiculo.version}`;

    fetch(url_tgm);
  };

  const scrollTop = () => {
    window.scroll({
      top: 0,
    });
  };

  let leyendaPrecioDolar =
    props.vehiculo.moneda == "U$S" ? "(Dolar Banco Nación)" : "";

  return (
    <div>
      <HeaderSecundario
        modelos={props.modelos}
        handleMostrarModal={props.handleMostrarModal}
      />
      <FormControl component="fieldset">
        <RadioGroup>
          <div className="row valign-wrapper contenedorGastos">
            <div className="col s12 m12 l6 center-align">
              {props.vehiculo && (
                <img
                  className="responsive-img fotoVehiculoGastos"
                  src={img + props.vehiculo.foto0}
                  alt="vehiculo seleccionado"
                />
              )}
              <div className="col s12 m6 offset-m3">
                {
                  <ul className="collapsible acordeon">
                    <li>
                      <div className="collapsible-header grey lighten-2">
                        <i className="material-icons">
                          <span style={{ color: "red" }}>add</span>
                        </i>
                        <b>ESPECIFICACIONES TECNICAS</b>
                      </div>
                      <div className="collapsible-body">
                        <span>
                          <ul>
                            <p>
                              <b>{props.vehiculo.version}</b>
                            </p>
                            <p>
                              <b>Chasis: </b>
                              {props.vehiculo.vin}
                            </p>
                            <p>
                              <b>Año: </b>
                              {props.vehiculo.anio}
                            </p>
                            <p>
                              <b>Color: </b>
                              {props.vehiculo.color}
                            </p>
                            <p>
                              <b>Tipo: </b>
                              {props.vehiculo.tipo}
                            </p>
                            <p>
                              <b>Transmision: </b>
                              {props.vehiculo.transmision}
                            </p>
                          </ul>
                        </span>
                      </div>
                    </li>
                  </ul>
                }
              </div>
            </div>
            <div className="col s12 m12 l6">
              <div className="row center-align">
                <h5 style={{ fontFamily: "Audi Extended" }}>
                  {" "}
                  {props.vehiculo.version}
                </h5>
                <h6 style={{ fontFamily: "Audi Normal" }}>
                  {" "}
                  seleccione como quiere patentar la unidad.
                </h6>
              </div>
              <div
                className="row center-align detalleGastos"
                style={{ display: "flex", marginRight: "0" }}
              >
                <div
                  className="col s12 m12 l8"
                  style={{ border: "1px solid grey", padding: "0px" }}
                >
                  <div
                    className={
                      clasePatentaConNosotros + " " + "col s12 m12 l12"
                    }
                    style={{
                      border: "0px solid grey",
                      borderRight: "none",
                      borderBottom: "1px solid grey",
                      padding: "0px",
                      display: "flex",
                    }}
                  >
                    <div className="col s12 m8 l8 left-align">
                      <FormControlLabel
                        value="1"
                        control={<Radio />}
                        onClick={patentaConNosotros}
                        label={
                          <div
                            style={{
                              fontSize: "18px",
                              fontFamily: "Audi Normal",
                              color: "black",
                            }}
                          >
                            <b>Patenta con nosotros</b>
                            <br />
                          </div>
                        }
                      />

                      <div
                        style={{
                          marginLeft: "30px",
                          fontSize: "12px",
                          marginBottom: "7%",
                        }}
                      >
                        <b>(Válido para Capital Federal y GBA)</b> Nos brinda su
                        documentación. Tomamos las firmas necesarias y retira la
                        unidad.
                        <br />
                        <span
                          style={{
                            marginTop: "2%",
                            fontFamily: "Audi Extended",
                            fontSize: "10px",
                          }}
                        >
                          <i>
                            A este importe se suma la patente que liquida el
                            registro
                          </i>
                        </span>
                      </div>
                    </div>
                    <div className="col s12 m4 l4" style={{ flex: "1" }}>
                      <div
                        style={{
                          marginTop: "5%",
                          fontFamily: "Audi Extended",
                          color: "black",
                          fontSize: "15pt",
                        }}
                      >
                        {props.vehiculo && props.vehiculo.moneda === "u$d"
                          ? "USD"
                          : "$"}{" "}
                        {Intl.NumberFormat("es-AR", {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        }).format(props.vehiculo.pat_emp)}
                        {pol_0km_Gastos !== 0 && (
                          <>
                            <div style={{ color: "red", fontSize: "15px" }}>
                              DESCUENTO ONLINE
                            </div>
                            <div style={{ color: "red", fontSize: "15px" }}>
                              {Intl.NumberFormat("es-AR", {
                                style: "currency",
                                currency: "ARS",
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              }).format(
                                props.vehiculo.pat_emp * pol_0km_Gastos
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={clasePatentaPorTuCuenta + " col s12 m12 l12"}
                    style={{
                      border: "0px solid grey",
                      borderRight: "none",
                      padding: "0px",
                      display: "flex",
                    }}
                  >
                    <div className="col s12 m8 l8 left-align">
                      <FormControlLabel
                        value="2"
                        control={<Radio />}
                        onClick={patentaPorTuCuenta}
                        label={
                          <div
                            style={{
                              fontSize: "18px",
                              fontFamily: "Audi Normal",
                              color: "black",
                            }}
                          >
                            <b>Patenta por su cuenta</b>
                            <br />
                          </div>
                        }
                      />

                      <div
                        style={{
                          marginLeft: "30px",
                          fontSize: "12px",
                          marginBottom: "5%",
                        }}
                      >
                        <b>(Válido para Capital Federal y GBA)</b> Entregamos
                        todos los formularios necesarios. Debe presentar la
                        documentación en el registro y programamos la entrega.
                      </div>
                    </div>
                    <div
                      className="col s12 m4 l4"
                      style={{
                        flex: "1",
                        marginTop: "1.2%",
                        fontFamily: "Audi Extended",
                        color: "black",
                        fontSize: "15pt",
                      }}
                    >
                      {props.vehiculo && props.vehiculo.moneda === "u$d"
                        ? "USD"
                        : "$"}{" "}
                      {Intl.NumberFormat("es-AR", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(props.vehiculo.pat_cli)}
                    </div>
                  </div>
                </div>
                <div
                  className="col s12 m6 l3 grey lighten-2 offset-m3"
                  style={{
                    border: "1px solid grey",
                    padding: "0px",
                    flex: "1",
                  }}
                >
                  <div
                    className="precioFinalTitulo"
                    style={{
                      marginTop: "10%",
                      fontFamily: "Audi Extended",
                      fontSize: "18px",
                    }}
                  >
                    Precio Final
                  </div>
                  {patent}
                  <div
                    style={{
                      marginTop: "2%",
                      fontFamily: "Audi Extended",
                      color: "black",
                      fontSize: "15pt",
                    }}
                  >
                    {props.vehiculo && props.vehiculo.moneda === "u$d"
                      ? "USD"
                      : "$"}{" "}
                    {Intl.NumberFormat("es-AR", {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    }).format(valorTotal)}
                  </div>
                  <div
                    className="li-version truncate center-align"
                    style={{ fontWeight: "bold", fontSize: "12px" }}
                  >
                    {leyendaPrecioDolar}
                  </div>

                  {patentamiento != null && props.vehiculo.moneda == "U$S" && (
                    <div
                      style={{
                        marginTop: "2%",
                        fontFamily: "Audi Extended",
                        color: "black",
                        fontSize: "15pt",
                      }}
                    >
                      {" "}
                      + <b>$</b>
                      {patentamiento == 0
                        ? props.vehiculo.pat_emp
                        : props.vehiculo.pat_cli}
                    </div>
                  )}

                  <Link
                    className="btn waves-effect hoverable white-text botonReservarMobile disabled"
                    id="botonReservar"
                    onClick={scrollTopAndReservar}
                    to="/Reserva"
                    style={{ marginTop: "5%" }}
                  >
                    <b>Continuar</b>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </RadioGroup>
      </FormControl>

      <CirculosRojos vehiculo={props.vehiculo} />

      <div
        className="row valign-wrapper"
        style={{ backgroundColor: "silver", height: "70px" }}
      >
        <h5 style={{ fontFamily: "Audi Extended", marginLeft: "5%" }}>
          Imagenes
        </h5>
      </div>
      <div className="row center-align valign-wrapper tarjeta">
        <div className="col s6 m3 l3 fotoGastos">
          <img
            className="responsive-img materialboxed"
            style={{ width: "650" }}
            src={img + props.vehiculo.foto1}
            alt="vehiculo seleccionado"
          />
        </div>
        <div className="col s6 m3 l3 fotoGastos">
          <img
            className="responsive-img materialboxed"
            style={{ width: "650" }}
            src={img + props.vehiculo.foto2}
            alt="vehiculo seleccionado"
          />
        </div>
        <div className="col s6 m3 l3 fotoGastos">
          <img
            className="responsive-img materialboxed"
            style={{ width: "650" }}
            src={img + props.vehiculo.foto3}
            alt="vehiculo seleccionado"
          />
        </div>
        <div className="col s6 m3 l3 fotoGastos">
          <img
            className="responsive-img materialboxed"
            style={{ width: "650" }}
            src={img + props.vehiculo.foto4}
            alt="vehiculo seleccionado"
          />
        </div>
      </div>
      <div className="row center-align valign-wrapper tarjeta">
        <div className="col s6 m3 l3 fotoGastos">
          <img
            className="responsive-img materialboxed"
            style={{ width: "650" }}
            src={img + props.vehiculo.foto5}
            alt="vehiculo seleccionado"
          />
        </div>
        <div className="col s6 m3 l3 fotoGastos">
          <img
            className="responsive-img materialboxed"
            style={{ width: "650" }}
            src={img + props.vehiculo.foto6}
            alt="vehiculo seleccionado"
          />
        </div>
        <div className="col s6 m3 l3 fotoGastos">
          <img
            className="responsive-img materialboxed"
            style={{ width: "650" }}
            src={img + props.vehiculo.foto7}
            alt="vehiculo seleccionado"
          />
        </div>
        <div className="col s6 m3 l3 fotoGastos">
          <img
            className="responsive-img materialboxed"
            style={{ width: "650" }}
            src={img + props.vehiculo.foto8}
            alt="vehiculo seleccionado"
          />
        </div>
      </div>
      <div
        className="li-version truncate center-align"
        style={{ fontWeight: "bold", fontSize: "12px", marginTop: "4%" }}
      >
        *Fotos no contractuales
      </div>
    </div>
  );
}
